import axios from 'axios';

import {
  SET_CURRENT_USER,
  ADD_ERROR,
  GET_CURRENT_USER_AGREEMENTS,
} from '../redux/types';
import { config } from '../config';
import { decodeAuthToken } from '../utils/authToken';

export function setAuthError(error) {
  return {
    type: ADD_ERROR,
    error,
  };
}

export function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    user,
  };
}

export function getAgreements(agreements) {
  return {
    type: GET_CURRENT_USER_AGREEMENTS,
    agreements,
  };
}

export function removeToken() {
  return dispatch => {
    localStorage.removeItem('token');
    dispatch(setCurrentUser({}));
  };
}

export function addToken(token) {
  return dispatch => {
    const user = decodeAuthToken(token);

    if (!user) {
      localStorage.removeItem('token');
      dispatch(setCurrentUser({}));
      return false;
    }

    localStorage.setItem('token', token);
    assignUserToPIVUsersGroup(user);

    dispatch(setCurrentUser(user));
    dispatch(fetchAgreements());
    return true;
  };
}

export function assignUserToPIVUsersGroup(user) {
  const PIV_USERS_EMAIL_DOMAIN = '@acf.hhs.gov'; //'@ams20.com';
  if (user.email && user.email.endsWith(PIV_USERS_EMAIL_DOMAIN)) {
    return axios
      .post(`/azure/users/${user.oid}/piv-users-group`, { user })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return null;
      });
  }
}

export function login() {
  return dispatch => {
    if (process.env.NODE_ENV === 'development') {
      window.location.href = `http://localhost:${config.API_PORT}/auth/login`;
    } else {
      window.location.href = '/auth/login';
    }
  };
}

export function logout() {
  return dispatch => {
    localStorage.removeItem('token');

    if (typeof window !== 'undefined') {
      if (process.env.NODE_ENV === 'development') {
        window.location.href = `http://localhost:${config.API_PORT}/auth/logout`;
      } else {
        window.location.href = '/auth/logout';
      }
    }
  };
}

export const fetchAgreements = () => dispatch =>
  axios
    .get(`/agreements/agreements`)
    .then(response => dispatch(getAgreements(response.data)));
